import {
  HTTP_COUNTRYSPECIAL_FETCHING,
  HTTP_COUNTRYSPECIAL_SUCCESS,
  HTTP_COUNTRYSPECIAL_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_COUNTRYSPECIAL_FETCHING:
      return { ...state, result: [], isLoading: true, isError: false };
    case HTTP_COUNTRYSPECIAL_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_COUNTRYSPECIAL_FAILED:
      return { ...state, result: [], isLoading: false, isError: true };
    default:
      return state;
  }
};
